import { FaLinkedin, FaXTwitter, FaSlack, FaGithub } from 'react-icons/fa6';
import BuiltByPill from '../ui/built-by-pill';

const navigation = {
  company: [
    { name: 'Home', href: '/home' },
    { name: 'Pricing', href: '/pricing' },
    { name: 'Blog', href: '/blog' },
    { name: 'Docs', href: 'https://docs.preswald.com' },
  ],
  social: [
    {
      name: 'Linkedin',
      href: 'https://www.linkedin.com/company/structuredlabs/',
      icon: FaLinkedin,
    },
    {
      name: 'X',
      href: 'https://x.com/StructuredLabs',
      icon: FaXTwitter,
    },
    {
      name: 'Slack',
      href: 'https://join.slack.com/t/structuredlabs-users/shared_invite/zt-33zwhyv3l-6Xu4bHL6b6~bI3z9fvlUig',
      icon: FaSlack,
    },
    {
      name: 'GitHub',
      href: 'https://github.com/StructuredLabs/preswald',
      icon: FaGithub,
    },
  ],
}

export default function Footer() {
  return (
    <footer aria-labelledby="footer-heading" className="bg-white">
      <div className="border-t border-gray-900/10 py-3 px-6 flex items-center justify-between">
        <BuiltByPill />
        <div className="flex items-center space-x-4">
          {navigation.company.map((item) => (
            <a
              key={item.name}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs leading-6 text-gray-600 hover:text-gray-900"
            >
              {item.name}
            </a>
          ))}
        </div>

        <div className="flex items-center space-x-4">
          {navigation.social.map((item) => {
            const Icon = item.icon;
            return (
              <a
                key={item.name}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-gray-500"
              >
                <span className="sr-only">{item.name}</span>
                <Icon className="h-5 w-5" />
              </a>
            );
          })}
        </div>
      </div>
    </footer>
  );
}
